import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BaseFillDataFormComponent} from '../base-fill-data-form-component';

@Component({
  selector: 'app-label-checkbox',
  templateUrl: './label-checkbox.component.html'
})
export class LabelCheckboxComponent extends BaseFillDataFormComponent {

  @Input() inputName: string;
  @Input() inputLabel: string;
  @Input() formGroup: FormGroup;
  @Input() labelOnRight: boolean;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/label-checkbox/label-checkbox.component.ts